import React from "react";
import { useT } from "@/lib/LanguageContext";
import { cn } from "../../../lib/utils";
import { FOCUS_RING } from "./classes";

/** Page numbers around the current one, with gaps: 1 … 4 5 6 … 12. */
const pageList = (page, pages) => {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const out = new Set([1, pages, page - 1, page, page + 1]);
  const sorted = [...out].filter((p) => p >= 1 && p <= pages).sort((a, b) => a - b);
  const withGaps = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) withGaps.push(null);
    withGaps.push(p);
  });
  return withGaps;
};

/** "50 per page · ‹ 1 2 ›" (wireframe). Renders the page-size caption even on one page. */
export default function CrmPager({ page, pageSize, total, onPage, testId }) {
  const t = useT("crm");
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const btn = cn("min-w-[1.75rem] rounded-full px-1.5 py-0.5 text-sm disabled:opacity-40", FOCUS_RING);
  return (
    <nav data-testid={testId} aria-label={t("pager.label")} className="flex items-center justify-between gap-4 pt-4 text-sm text-eh-muted">
      <span>{t("pager.perPage", { n: pageSize })}</span>
      <span className="flex items-center gap-0.5">
        <button type="button" className={btn} disabled={page <= 1} onClick={() => onPage(page - 1)} aria-label={t("pager.previous")}>‹</button>
        {pageList(page, pages).map((p, i) => (p === null
          ? <span key={`gap-${i}`} aria-hidden="true">…</span>
          : (
            <button key={p} type="button" onClick={() => onPage(p)} aria-current={p === page ? "page" : undefined}
              className={cn(btn, p === page ? "font-bold text-eh-ink" : "text-eh-muted")}>{p}</button>
          )))}
        <button type="button" className={btn} disabled={page >= pages} onClick={() => onPage(page + 1)} aria-label={t("pager.next")}>›</button>
      </span>
    </nav>
  );
}
